import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetabaseEmbedComponent } from '../../../components/metabase-embed/metabase-embed.component';
import { UserProfileService } from '../../../services/user/user-profile.service';
import { environment } from '../../../../environments/environment';

/**
 * PayPoint bill-payment reports (prepaid electricity, airtime, Pay TV, wallets).
 * Embeds the client-agnostic Metabase dashboard; the logged-in user's
 * organisation id is locked into the signed token so each client only
 * sees its own transactions.
 */
@Component({
  selector: 'app-paypoint-reports',
  standalone: true,
  imports: [CommonModule, MetabaseEmbedComponent],
  templateUrl: './paypoint-reports.component.html',
  styleUrl: './paypoint-reports.component.css',
})
export class PaypointReportsComponent {
  private userService = inject(UserProfileService);
  readonly payPointConfig = environment.metabasePayPoint;
  readonly orgId = this.userService.jwtOrgId;
}
